import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToTrailer = {
  [titleId: string]: WpsTypes.atv.wps.TrailerFragmentModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.trailer,
  {} as TitleIdToTrailer
)
